import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Box, Button } from "@chakra-ui/react";
import ReactDataTable from "../../../components/PrimaryTable";
import DataTableColumns from "../../../components/DataTableColumns";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../layout";
import {
  fetchDashboardSummaryRequest,
  fetchDoctorReminderRequest,
  resetDoctorReminder,
} from "../ipsStore/actions";
import Alert from "../../../components/Alert";
import { filtersPayload } from "../../utils";

const GenericPatientDetailsList = ({
  header,
  screen,
  iconUrl,
  showBulkApproval,
  onBulkApproval,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const { dashboardSummary, doctorReminderResponse } = useSelector(
    (state) => state.ips
  );

  const isBulkApprovalPath = location.search.includes("Bulk%20Approval");

  const label =
    searchParams.get("label") || location.state?.label || "No Label";

  const [selectedRows, setSelectedRows] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [reminderResponse, setReminderResponse] = useState(null);
  const [filters, setFilters] = useState({
    country: [],
    healthConcern: [],
    hospital: [],
    gender: [],
    daysFilter: "",
    fromDate: "",
    toDate: "",
    dateError: "",
  });
  useEffect(() => {
    const payload = {
      source: "Web",
      screen: screen,
      status_name: label,
    };
    dispatch(fetchDashboardSummaryRequest(payload));
  }, [label, screen, dispatch]);

  useEffect(() => {
    if (doctorReminderResponse) {
      setReminderResponse(doctorReminderResponse);
    }
  }, [doctorReminderResponse]);

  useEffect(() => {
    if (reminderResponse) {
      setShowAlert(true);
    }
  }, [reminderResponse]);

  useEffect(() => {
    return () => {
      dispatch(resetDoctorReminder());
    };
  }, [dispatch]);

  // const handleDateFilterApply = (dateRange) => {
  //   let payload = new FormData();

  //   payload.append("from_date", dateRange.fromDate);
  //   payload.append("to_date", dateRange.toDate);
  //   payload.append("screen", screen);
  //   payload.append("source", "Web");
  //   payload.append("status_name", label);

  //   dispatch(fetchDashboardSummaryRequest(payload));
  // };
  const handleFilter = () => {
    let payload = filtersPayload(
      filters.healthConcern,
      filters.hospital,
      filters.gender,
      filters.country,
      filters.daysFilter,
      filters.fromDate,
      filters.toDate
    );
    // payload.filters = true;
    payload.screen = screen;
    payload.source = "web";
    payload.status_name = label;
    dispatch(fetchDashboardSummaryRequest(payload));
  };

  const refreshData = () => {
    const payload = {
      source: "Web",
      screen: screen,
      status_name: label,
    };
    setReminderResponse(null);
    dispatch(fetchDashboardSummaryRequest(payload));
  };

  const handleRemindClick = (trId) => {
    dispatch(
      fetchDoctorReminderRequest({
        tr_id: trId,
      })
    );
  };

  const handleAlertClose = () => {
    setShowAlert(false);
    setReminderResponse(null);
    refreshData();
  };

  return (
    <Layout
      header={`${header} - ${label}`}
      iconUrl={iconUrl}
      showDateFilters={false}
      showFilters={true}
      handleFilter={handleFilter}
      setFilters={setFilters}
      filters={filters}
      // handleDateFilterApply={handleDateFilterApply}
    >
      <Box
        minHeight="800px"
        bgColor={"#ffff"}
        ml="10px"
        shadow="md"
        borderWidth="1px"
        borderRadius="md"
      >
        {showBulkApproval && isBulkApprovalPath && (
          <Box display="flex" justifyContent="flex-end" p={4}>
            <Button
              colorScheme="blue"
              onClick={() => onBulkApproval(selectedRows, refreshData)}
              isDisabled={
                selectedRows.length === 0 || !dashboardSummary?.length
              }
            >
              Bulk Approval
            </Button>
          </Box>
        )}
        <ReactDataTable
          columns={DataTableColumns(header, label, handleRemindClick)}
          data={dashboardSummary ? dashboardSummary : ""}
          selectableRows={isBulkApprovalPath}
          onSelectedRowsChange={({ selectedRows }) =>
            setSelectedRows(selectedRows)
          }
        />
      </Box>

      <Alert
        isOpen={showAlert}
        onClose={handleAlertClose}
        title="Success"
        body={reminderResponse?.message}
        type="success"
        showCancelButton={false}
      />
    </Layout>
  );
};

export default GenericPatientDetailsList;
